
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Preview } from "@lighting-beetle/lighter-styleguide";
import { Checkbox, Input, Radio, Select, Textarea } from "./../index";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Message`}</h1>
    <h2>{`Example`}</h2>
    <Input id="example" placeholder="Help" help="This is help message" label="Label" mdxType="Input" />
    <h2>{`Variants`}</h2>
    <h3>{`Help`}</h3>
    <Preview mdxType="Preview">
  <Input id="help-input" placeholder="Help" help="This is help message" label="Label" mdxType="Input" />
  <Textarea id="help-textarea" placeholder="Help" help="This is help message" label="Label" mdxType="Textarea" />
  <Checkbox id="help-checkbox" help="This is help message" mdxType="Checkbox">
    Help
  </Checkbox>
  <Radio id="help-radio" help="This is help message" mdxType="Radio">
    Help
  </Radio>
  <Select id="help-select" help="This is help message" label="Label" mdxType="Select">
    <option>Item 1</option>
    <option>Item 2</option>
  </Select>
    </Preview>
    <h3>{`Error`}</h3>
    <Preview mdxType="Preview">
  <Input id="error-input" value="Error" error="This is error message" label="Label" mdxType="Input" />
  <Textarea id="error-textarea" value="Error" error="This is error message" label="Label" mdxType="Textarea" />
  <Checkbox id="error-checkbox" error="This is error message" mdxType="Checkbox">
    Error
  </Checkbox>
  <Radio id="error-radio" error="This is error message" mdxType="Radio">
    Error
  </Radio>
  <Select id="error-select" error="This is error message" label="Label" mdxType="Select">
    <option>Item 1</option>
    <option>Item 2</option>
  </Select>
    </Preview>
    <h2>{`Acessibility`}</h2>
    <p>{`Messages currently do not implement any accessibility features. Make sure to add `}<inlineCode parentName="p">{`aria-describedby`}</inlineCode>{` attribute pointing to individual messages and `}<inlineCode parentName="p">{`aria-invalid`}</inlineCode>{` attribute to fields with errors.
\`;`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;